import { useEffect, useState } from "react";
import styles from './app.module.scss';
import { useLocation, useNavigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Toast from "../Toast/Toast";
import { SnackbarProvider } from 'notistack';
import { AppProps } from '../../interfaces/components';
import { useIsMobileDevice } from "../../helpers/hooks";
import MetaDecoration from "../MetaDecoration/MetaDecoration";
import NavBar from '../../containers/NavBar/NavBarContainer';
import Footer from '../../containers/Footer/FooterContainer';
import { dev } from "../../config/api";
import Routes from "../../containers/RoutesContainer";
import RefreshToken from '../../containers/RefreshToken/RefreshTokenContainer';
import { useWindowSize } from "use-hooks";
import ModalDownloadApp from "../ModalDownloadApp";

const App = ({ user }: AppProps) => {
	const location = useLocation();
	const windowSize = useWindowSize();
	const navigate = useNavigate();
	const isMobileDevice = useIsMobileDevice();
	const [openDownloadModal, setOpenDownloadModal] = useState<boolean>(false);
	const helmetContext = {};

	useEffect(() => {
		if(!dev && isMobileDevice && !(location.pathname === "/" || location.pathname.match("/frequent_questions") || location.pathname.match("/publication/") || location.pathname.match("/linze_ai"))){
			setOpenDownloadModal(true);
		}else{
			setOpenDownloadModal(false);
		}
	}, [windowSize.width, location]);

	useEffect(() => {
		if(user?.first_login && location?.pathname !== "/"){
			navigate('/');
		}
	}, [location]);

	return (
		<HelmetProvider context={helmetContext}>
			<SnackbarProvider content={(key, message) => <Toast id={key} content={message} />}>
				<MetaDecoration />
				<RefreshToken />
				<div className={styles.app}>
					{
						user && location.pathname !== "/" && <NavBar />
					}
					<Routes />
				</div>
				{
					user && location.pathname !== "/" && <Footer />
				}
			</SnackbarProvider>
		</HelmetProvider>
	);
}

export default App;
